// extracted by mini-css-extract-plugin
export default {"allTimeActive":"style_allTimeActive__PmZLI"};